/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import WebGLRenderGraph from "App/render/webgl/render_graph";
import Opaque from "App/render/webgl/nodes/bins/opaque_bin";
import Factory from "App/render/webgl/nodes/bins/factory";
import {TransparentBinTypeName} from "App/render/webgl/nodes/bins/type_names";
import IScene from "js_interface/src/scene_interface";

export default
class Transparent extends Opaque {

    public static TypeName: string = TransparentBinTypeName;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): Transparent {
        return new Transparent(aSceneAPI, aRenderGraph);
    }
}

Factory.register(Transparent);
